import passengersActionCreators, { actionTypes } from './passengersActions';

export default passengersActionCreators;
export { actionTypes };
